import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'

@inject((store: any) => {
    const { collectionsStore, popupStore } = store
    return { collectionsStore, popupStore }
})
@observer
class Collection extends Component<any, any> {
    render() {
        const {
            source_id,
            name,
            description,
            categories,
            servicefields,
            type_name
        } = this.props.collectionsStore.collection
        const style = { padding: '0.5rem 0', fontSize: '1rem', borderBottom: '1px solid #c5c5c5' }
        return (
            <div>
                <div style={style}>
                    {source_id !== 'LOCAL' ? (
                        <a
                            style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                            target="_blank"
                            href={`http://call.health.gov.il/infocenter/index?page=content&id=${source_id}`}
                        >
                            קישור למקור
                        </a>
                    ) : (
                        'הזכות נוצרה במערכת'
                    )}
                </div>
                <div style={style}>
                    <label>
                        <strong>שם הזכות</strong>
                    </label>
                    <div>{name}</div>
                </div>
                <div style={style}>
                    <label>
                        <strong>תיאור</strong>
                    </label>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <div style={style}>
                    <label>
                        <strong>שיוך לקטגוריות</strong>
                    </label>
                    <div>
                        {categories && categories.length > 0
                            ? categories.map((category, index) => (
                                  <span key={index}>
                                      {index > 0 ? '  /  ' : ''}
                                      {category.name}
                                  </span>
                              ))
                            : 'אין שיוך לקטגוריות'}
                    </div>
                </div>
                <div style={style}>
                    <label>
                        <strong>שיוך לתחומים</strong>
                    </label>
                    <div>
                        {servicefields && servicefields.length > 0
                            ? servicefields.map((servicefield, index) => (
                                  <span key={index}>
                                      {index > 0 ? '  /  ' : ''}
                                      {servicefield.name}
                                  </span>
                              ))
                            : 'אין שיוך לתחומים'}
                    </div>
                </div>
                <div style={style}>
                    <label>
                        <strong>סוג הזכות</strong>
                    </label>
                    <div>{type_name ? type_name : 'ללא סוג'}</div>
                </div>
            </div>
        )
    }
}

export default withRouter(Collection)
